import * as React from "react";

import { Goal, Hint, HintedSuitedNumber, Suit, SuitedNumber } from "../common";
import { Card, Size } from "./Card";

interface Props {
  name: string;
  isCommander: boolean;
  goals: Goal[];
  hinted: HintedSuitedNumber | boolean;
}

interface State {
  played: SuitedNumber | null;
  hinted: HintedSuitedNumber | boolean;
  achievedGoals: Goal[];
}

export class Player extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      played: null,
      hinted: props.hinted,
      achievedGoals: []
    };
  }

  render() {
    let commander;
    if (this.props.isCommander) {
      commander = (
        <div className="commander">
          <img src="https://upload.wikimedia.org/wikipedia/commons/0/0c/Chris_Hadfield_2011.jpg" />
        </div>
      );
    }

    let hint;
    if (this.state.hinted === false) {
      hint = (
        <div className="hintContainer">
          <div className="hint"></div>
        </div>
      );
    } else if (this.state.hinted === true) {
      hint = (
        <div className="hintContainer">
          <div className="hint used"></div>
        </div>
      );
    } else {
      const { suit, number } = this.state.hinted.suitedNumber;
      hint = (
        <Card
          size={Size.Large}
          number={number}
          suit={suit}
          hint={this.state.hinted.hint}
          canHint={false}
        />
      );
    }

    const goals = this.props.goals.map(goal => (
      <Card
        size={Size.Small}
        number={goal.suitedNumber.number}
        suit={goal.suitedNumber.suit}
        hint={Hint.None}
        canHint={false}
      />
    ));

    return (
      <div className="player">
        <div className="name">{this.props.name}</div>
        {commander}
        <div className="goals">{goals}</div>
        <div className="player-hint">{hint}</div>
      </div>
    );
  }
}
